import api, { buildURLWithParams } from '@/services/api';

import {
  type RoadmapPortfolioDTO,
  type RoadmapPortfolioResourceDTO,
  type RoadmapPortfolioResourceGroupDTO,
} from '../types';

const BASE_URL = 'portfolio';

export const getPortfolios = async () => {
  return await api.get<RoadmapPortfolioDTO[]>(BASE_URL);
};

export const getItemsWithYears = async (years: number[]) => {
  const params = new URLSearchParams();
  years.forEach((y) => params.append('years', String(y)));
  return await api.get<RoadmapPortfolioDTO[]>(`${BASE_URL}/by-years?${params.toString()}`);
};

export const savePortfolios = async (portfolios: RoadmapPortfolioDTO[]) => {
  await api.post(BASE_URL, portfolios);
};

export const deletePortfolios = async (portfolios: RoadmapPortfolioDTO[]) => {
  await api.delete(BASE_URL, portfolios);
};

export const getResourceGroupsByPortfolio = async (
  roadmapIds: number[],
  filterCostCenter = false,
  signal?: AbortSignal,
) => {
  return await api.post<RoadmapPortfolioResourceGroupDTO[]>(
    buildURLWithParams(`${BASE_URL}/resources/groups`, { filterCostCenter }),
    roadmapIds,
    { signal },
  );
};

export const getResourceGroupsOwnerByPortfolio = async (roadmapIds: number[], signal?: AbortSignal) => {
  return await api.post<RoadmapPortfolioResourceGroupDTO[]>(`${BASE_URL}/resources/groups/owner`, roadmapIds, {
    signal,
  });
};

export const getResourcesByPortfolio = async (roadmapIds: number[], signal?: AbortSignal) => {
  return await api.post<RoadmapPortfolioResourceDTO[]>(`${BASE_URL}/resources`, roadmapIds, { signal });
};

export const getResourcesOwnerByPortfolio = async (roadmapIds: number[], signal?: AbortSignal) => {
  return await api.post<RoadmapPortfolioResourceDTO[]>(`${BASE_URL}/resources/owner`, roadmapIds, { signal });
};

export const lockRoadmapsByPortfolio = async (portfolioId: number, lockState: boolean, roadmapIds?: number[]) => {
  await api.put(buildURLWithParams(`${BASE_URL}/${portfolioId}/lock`, { lockState }), roadmapIds ?? []);
};

export const unlockRoadmapsByPortfolio = async (portfolioId: number, lockState: boolean, roadmapIds?: number[]) => {
  await api.put(buildURLWithParams(`${BASE_URL}/${portfolioId}/unlock`, { lockState }), roadmapIds ?? []);
};
